"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateOfferItem = void 0;
var BasketUpdated = _interopRequireWildcard(require("@ori-events/basket-updated"));
var UpdateOfferItem = _interopRequireWildcard(require("@ori-events/update-offer-item"));
var UpdateOfferItemFailed = _interopRequireWildcard(require("@ori-events/update-offer-item-failed"));
var _analyticsData = require("@ori/analytics-data");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
// istanbul ignore file -- api

/**
 * Updates the quantity of an offer item in the basket.
 */
const updateOfferItem = async ({
  choiceId,
  itemCode,
  localName,
  quantity,
  formattedPrice,
  position
}) => new Promise((resolve, reject) => {
  const listener = event => {
    window.removeEventListener(BasketUpdated.Name, listener);
    window.removeEventListener(UpdateOfferItemFailed.Name, listener);
    const {
      detail
    } = event;
    if (UpdateOfferItemFailed.isUpdateOfferItemFailedResponse(detail)) {
      reject(new Error(`update-offer-item error: ${detail.message}`));
    } else {
      resolve(true);
    }
  };
  window.addEventListener(BasketUpdated.Name, listener);
  window.addEventListener(UpdateOfferItemFailed.Name, listener);
  const event = new CustomEvent(UpdateOfferItem.Name, {
    detail: {
      choiceId,
      itemCode,
      localName,
      quantity,
      formattedPrice,
      placement: _analyticsData.Placement.Offers,
      position
    }
  });
  window.dispatchEvent(event);
});
exports.updateOfferItem = updateOfferItem;